module.exports = __webpack_public_path__ + "img/usgs.8b9f6101.svg";